export default "__VITE_ASSET__DWSiyF$N__"